// extracted by mini-css-extract-plugin
module.exports = {"ellipse":"ArticleInfoItem_ellipse__VT_RJ"};